import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import React from 'react';

import type { IShoppingProduct } from 'v2/interfaces/shopping';

import useStyle from '../styles';
import { BuyerDetails } from './buyerDetails';
import { ChangePaymentMethod } from './changePaymentMethod';
import InvoiceDetails from './invoiceDetails';

interface IProps {
  shopping: IShoppingProduct;
  closeQuickView: () => void;
}

const Ticket = ({ shopping, closeQuickView }: IProps) => {
  const classes = useStyle();
  return (
    <>
      <div className={classes.quickviewDataBasic}>
        <Grid container spacing={2}>
          <Grid item md={4} sm={12} xs={12}>
            <div className='image' style={{ backgroundImage: `url(${shopping.product.image})` }}></div>
          </Grid>

          <Grid item md={8} sm={12} xs={12}>
            <div className='info'>
              <h2>{shopping.product.title}</h2>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className='m24'></div>

      <BuyerDetails shopping={shopping} />

      <div className='m24'></div>

      <div className={classes.sender}>
        <div className='data'>
          <span>Data: </span> {shopping.product.event.date ? moment(shopping.product.event.date).format('DD/MM/YYYY') : '-'}
        </div>
        <div className='data'>
          <span>Horário: </span> {shopping.product.event.date ? moment(shopping.product.event.date).format('H:mm') : '-'}
        </div>
        <div className='data'>
          <span>Endereço: </span>
          {shopping.product.event.address.street + ', '}
          {shopping.product.event.address.number + ' - '}
          {shopping.product.event.address.neighborhood + ' - '}
          {shopping.product.event.address.city + ' - '}
          {shopping.product.event.address.state}
        </div>
      </div>

      <div className='m24'></div>

      <InvoiceDetails shopping={shopping} />

      <div className='m8' />

      {shopping.unlimited_installment && <ChangePaymentMethod shopping={shopping} closeQuickView={closeQuickView} />}
    </>
  );
};

export default Ticket;
